import {
  useState, useRef, useCallback, useEffect,
} from 'react';

const POPOVER_HIDE_DELAY_MS = 1000;

export const usePopover = () => {
  const [showPopover, setShowPopover] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);
  const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const cancelHideTimeout = useCallback(() => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
  }, []);

  const handleMouseEnter = useCallback(() => {
    cancelHideTimeout();
    setShowPopover(true);
  }, [cancelHideTimeout]);

  const handleMouseLeave = useCallback(() => {
    hideTimeoutRef.current = setTimeout(() => {
      setShowPopover(false);
    }, POPOVER_HIDE_DELAY_MS);
  }, []);

  useEffect(() => () => {
    cancelHideTimeout();
  }, [cancelHideTimeout]);

  return {
    showPopover,
    triggerRef,
    popoverRef,
    handleMouseEnter,
    handleMouseLeave,
  };
};
